import React from "react";
import { useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { Box, HStack, Text } from "@chakra-ui/react";

interface Props {
  handleOnClick?: () => void;
  page?: string;
}

const BackLink = ({ handleOnClick, page }: Props) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (handleOnClick) {
      handleOnClick();
    } else if (page) {
      navigate(page);
    } else {
      navigate(-1);
    }
  };

  return (
    <Box w="full" my={3}>
      <HStack
        color="blue.500"
        cursor="pointer"
        onClick={handleClick}
        spacing={1}
      >
        <IoIosArrowRoundBack size="25px" />
        <Text fontWeight="bold">Back</Text>
      </HStack>
    </Box>
  );
};

export default BackLink;
